export const ONESIGNAL_APP_ID = "f7b5c4e4-4b85-436c-9196-871a122a1dee";
